module.exports = __webpack_public_path__ + "img/logo-blanc-transparent.deb5045c.png";